'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* -----------  PASSWORD RECOVERY  ------------------------ */

var PasswordRecoveryResponse = _react2['default'].createClass({
    displayName: 'PasswordRecoveryResponse',


    propTypes: {
        // Currently ignored for security reasons (message ambiguity)
        'isSuccessful': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {
        if (process.env.NODE_ENV !== 'test') {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
        if (process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    render: function render() {

        var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
        var mailtoLink = 'mailto:' + supportEmail + '?subject=' + encodeURIComponent('Password Reset');
        var msg = _react2['default'].createElement(
            'span',
            null,
            _react2['default'].createElement(
                'p',
                null,
                'If that is a valid address, we have sent an email to it to reset your password.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'If you\'re still experiencing difficulties, please contact us at\xA0',
                _react2['default'].createElement(
                    'a',
                    { href: mailtoLink },
                    supportEmail
                ),
                '.'
            )
        );

        return _react2['default'].createElement(
            'div',
            { className: 'row text-center' },
            _react2['default'].createElement(
                'div',
                { className: 'columns small-12' },
                _react2['default'].createElement(
                    'h4',
                    null,
                    'Thanks!'
                ),
                msg
            )
        );
    }
});

module.exports = PasswordRecoveryResponse;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/password-recovery-response.jsx
 ** module id = 880
 ** module chunks = 0
 **/